import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface collectDrawNumRequest extends BaseRequest {
  invId: string; //邀请活动ID
  /**
   * 被邀请人通行证
   * */
  binvUid: string;
  /**
   * 项目id
   */
  projectId: string;
  /**
   * 任务编码
   * */
  taskCode: string;
}

export interface CollectDrawNumResVO {}

interface getSumCashResponse extends BaseResponse {
  Data: CollectDrawNumResVO;
}

/**
 * 领取抽奖次数
 * 邀请进度页面，单个领取抽奖次数
 * */
export async function collectDrawNum(request: collectDrawNumRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/collectDrawNum');
  return DsbcApi.fetch<getSumCashResponse>(url, request, true, options);
}
